import { Button, Divider, FormControl, IconButton, InputAdornment, InputLabel, Modal, OutlinedInput, Typography } from '@mui/material'
import React, { useState } from 'react'
import { ModalReset } from './styled.components'
import CloseIcon from '@material-ui/icons/Close';
import { useHistory } from 'react-router-dom';
import { notifica } from '../../../requests/utils';
import { actualizarPasswordCandidato } from '../../../requests/login';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import ClockLoader from "react-spinners/ClockLoader";

export default ({ open, handleClose, infoCandidato, procesoLogin }) => {
    let history = useHistory();
    const [passwordOne, setPasswordOne] = useState('');
    const [passwordSecond, setPasswordSecond] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false)

    const cambioContrasena = async () => {
        if (!passwordOne) { return notifica("warning", "Ingresa password", "Alerta") }
        if (!passwordSecond) { return notifica("warning", "Ingrese Confirmacion", "Alerta") }
        if (passwordOne.trim() !== passwordSecond.trim()) { return notifica("warning", "las contraseñas no cohinciden", "Alerta") }
        if (!infoCandidato) {
            notifica("warning", "hubo un error en la configuracion del portal favor de reintentar", "Alerta")
            history.push("/")
        }
        setIsLoading(true);
        let data = await actualizarPasswordCandidato(infoCandidato.idCandidato, passwordOne);
        if (data) {
            procesoLogin(infoCandidato);
        }else{
            setIsLoading(false);
        }
    }

    const close = () => {
        setPasswordOne("");
        setPasswordSecond("");
        setIsLoading(false);
        handleClose();
    }

    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = (event) => event.preventDefault();


    return (
        <Modal
            open={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <ModalReset>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    Es necesario actualizar tu contraseña
                    {!isLoading
                        ? (<IconButton style={{ color: "#F5A796" }} onClick={close} aria-label="upload picture" component="span">
                            <CloseIcon />
                        </IconButton>)
                        : <ClockLoader color={"#f5a796"} size={30} />
                    }

                </Typography>
                <Divider style={{ backgroundColor: '#F5A796', height: '1px' }} />
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    Para poder continuar ingresa tu nueva contraseña
                </Typography>
                <div>
                    <FormControl id="password-1" className='reset-password' sx={{ width: '100%' }} variant="outlined">
                        <InputLabel htmlFor="standard-adornment-password">Ingrese contraseña</InputLabel>
                        <OutlinedInput
                            id="standard-adornment-password"
                            type={showPassword ? 'text' : 'password'}
                            value={passwordOne}
                            onChange={e => setPasswordOne(e.target.value)}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="Ingrese Contraseña"
                        />
                    </FormControl>
                    <FormControl id="password-1" className='reset-password' sx={{ width: '100%' }} variant="outlined">
                        <InputLabel htmlFor="standard-adornment-password">Confirmar contraseña</InputLabel>
                        <OutlinedInput
                            id="standard-adornment-password"
                            type={showPassword ? 'text' : 'password'}
                            value={passwordSecond}
                            onChange={e => setPasswordSecond(e.target.value)}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="Confirmar contraseña"
                        />
                    </FormControl>
                    {!isLoading ?
                        (<div className='options'>
                            <Button style={{ borderColor: "#F5A796", color: "#F5A796" }} onClick={close} className='btnOption' variant="outlined">Cancelar</Button>
                            <Button style={{ backgroundColor: "#F5A796" }} onClick={cambioContrasena} className='btnOption' variant="contained">Confirmar</Button>
                        </div>)
                        : <ClockLoader color={"#f5a796"} size={30} />}
                </div>
            </ModalReset>
        </Modal>
    )
}
